import { Instant, LocalDate, LocalDateTime } from "@js-joda/core";
import { dateFormatter } from "../../shared/utils/date-formatter";
import { PatientProfilePatient } from "./patientProfileModal.types";

export function getPatientPhotoUrl(patient: PatientProfilePatient) {
  return patient.gender === "M" ? "admin/images/patient-men.png" : "admin/images/patient-women.png";
}

export function formatPatientProfileValue(value: unknown) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  if (value instanceof LocalDate) {
    return dateFormatter.toDate(value);
  }

  if (value instanceof LocalDateTime || value instanceof Instant) {
    return dateFormatter.toDateTime(value);
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  return String(value);
}
